{
  "name": "transport-partners",
  "version": "3.13.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build-themes": "devextreme build",
    "postinstall": "npm run build-themes",
    "release:minor": "standard-version --release-as minor",
    "prebuild:prod": "npm run release:minor",
    "build:prod": "ng build --configuration=production",
    "zip:prod": "node -e \"const pkg=require('./package.json'); const { execSync } = require('child_process'); execSync(`Compress-Archive -Path ./dist/transport-partners -DestinationPath ./dist/transport-partners-${pkg.version}.zip`, { stdio: 'inherit', shell: 'powershell.exe' });\""
  },
  "private": true,
  "dependencies": {
    "@almothafar/angular-signature-pad": "^6.0.0",
    "@angular/animations": "^18.1.0",
    "@angular/cdk": "~18.1.0",
    "@angular/common": "^18.1.0",
    "@angular/compiler": "^18.1.0",
    "@angular/core": "^18.1.0",
    "@angular/forms": "^18.1.0",
    "@angular/platform-browser": "^18.1.0",
    "@angular/platform-browser-dynamic": "^18.1.0",
    "@angular/router": "^18.1.0",
    "@ericblade/quagga2": "^1.8.4",
    "@ngx-translate/core": "^16.0.3",
    "@ngx-translate/http-loader": "^16.0.0",
    "@syncfusion/ej2-angular-inputs": "^28.2.3",
    "@zxing/browser": "^0.1.5",
    "@zxing/ngx-scanner": "^18.0.1",
    "angular-signature": "^1.0.3",
    "country-flag-icons": "^1.5.14",
    "date-fns": "^4.1.0",
    "devextreme": "24.1.4",
    "devextreme-angular": "24.1.4",
    "devextreme-schematics": "^1.7.1",
    "flag-icon-css": "^4.1.7",
    "flag-icons": "^7.3.2",
    "ngx-barcode-scanner": "^14.0.1",
    "ngx-image-compress": "^18.1.5",
    "ngx-scanner": "^0.0.0",
    "ngx-scanner-qrcode": "^1.6.9",
    "ngx-signaturepad": "^0.0.10",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.1.1",
    "@angular/cli": "^18.1.1",
    "@angular/compiler-cli": "^18.1.0",
    "@types/jasmine": "~5.1.0",
    "devextreme-cli": "latest",
    "devextreme-themebuilder": "24.1.4",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "standard-version": "^9.5.0",
    "typescript": "~5.5.2"
  }
}
